// @flow

import React from 'react';

import { type PaymentSpec } from './types';

export const PaymentSpecContext = React.createContext<?PaymentSpec>(null);
